import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';
import URI from 'urijs';

import { BookingFooterItem } from 'Components/widgets/booking-footer/BookingFooterItem';
import { useAppContext } from 'Context/ReactAppContext';

export const BookingFooter = ({ footer, className }) => {
  const { locale } = useAppContext();

  // we add number phone callCenter to link on click booking.callCenterPopIn.number
  const completedItemsFooter = footer.contactsBarBE?.map((item) => {
    // phone number link
    if (item.href === '' && item.type === 'callMeBack') {
      return { ...item, href: 'tel://' + t('booking.callCenterPopIn.number').replace(/\s+/g, '') };
    }
    // store Locator link
    if (item.type === 'storeLocator') {
      return item;
    }
    // other links with locale
    return { ...item, href: new URI(item.href).addQuery('locale', locale) };
  });

  // for now the maximum active class in tailwind grid column is grid-cols-6
  // so if we have 0 or > 6 items we will use 6 columns which is the maximum
  // doesn't seem to work with media queries so ...
  const MAX_ITEMS_FOR_GRID_CSS = 6;
  const nbItems = completedItemsFooter?.length;
  const numberOfItemsMax6 = nbItems <= MAX_ITEMS_FOR_GRID_CSS ? nbItems : MAX_ITEMS_FOR_GRID_CSS;
  const gridClassDynamic = `md:grid-cols-${numberOfItemsMax6}`;
  if (!completedItemsFooter) {
    return null;
  }
  return (
    <div className={classnames('w-ful flex items-center justify-center border-t-1', className)}>
      <div
        className={classnames(
          'grid grid-cols-2 items-start gap-20 p-20 md:w-1/2',
          gridClassDynamic,
        )}
      >
        {completedItemsFooter.map((footerItem, index) => {
          return (
            <BookingFooterItem
              key={`${completedItemsFooter[index]?.type}-${index * 2}`}
              {...footerItem}
            />
          );
        })}
      </div>
    </div>
  );
};
